/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'network-security-policy';
const componentName = 'network-security-rule-modal';
const prefix = `${moduleName}.${componentName}`;

export const modalTitleEdit = `${prefix}.modalTitleEdit`;
export const modalTitleNew = `${prefix}.modalTitleNew`;
export const sectionTitleGeneral = `${prefix}.sectionTitleGeneral`;
export const sectionTitleMatch = `${prefix}.sectionTitleMatch`;
export const sectionTitleAction = `${prefix}.sectionTitleAction`;
export const nameInputLabel = `${prefix}.nameInputLabel`;
export const nameInputPlaceholder = `${prefix}.nameInputPlaceholder`;
export const enableRuleLabel = `${prefix}.enableRuleLabel`;
export const enableLoggingLabel = `${prefix}.enableLoggingLabel`;
export const connectionBurstSizeLabel = `${prefix}.connectionBurstSizeLabel`;
export const connectionBurstSizePlaceholder = `${prefix}.connectionBurstSizePlaceholder`;
export const maxRateLabel = `${prefix}.maxRateLabel`;
export const maxRatePlaceholder = `${prefix}.maxRatePlaceholder`;
export const ruleIndexLabel = `${prefix}.ruleIndexLabel`;
export const clientIpLabel = `${prefix}.clientIpLabel`;
export const ipReputationMatchLabel = `${prefix}.ipReputationMatchLabel`;
export const portMatchLabel = `${prefix}.portMatchLabel`;
export const allowLabel = `${prefix}.allowLabel`;
export const denyLabel = `${prefix}.denyLabel`;
export const rateLimitLabel = `${prefix}.rateLimitLabel`;
export const networkSecurityRuleActionLabel = `${prefix}.networkSecurityRuleActionLabel`;
export const networkSecurityRuleActionPlaceholderLabel = `${prefix}.networkSecurityRuleActionPlaceholderLabel`;
export const geoMatchesLabel = `${prefix}.geoMatchesLabel`;

export const ENGLISH = {
    [modalTitleEdit]: 'Edit Network Security Rule: {0}',
    [modalTitleNew]: 'New Network Security Rule: {0}',
    [sectionTitleGeneral]: 'General',
    [sectionTitleMatch]: 'Match',
    [sectionTitleAction]: 'Action',
    [nameInputLabel]: 'Name',
    [nameInputPlaceholder]: 'Enter Name',
    [enableRuleLabel]: 'Enable Rule',
    [enableLoggingLabel]: 'Enable Logging',
    [connectionBurstSizeLabel]: 'Connection Burst Size',
    [connectionBurstSizePlaceholder]: 'Enter Size',
    [maxRateLabel]: 'Maximum Rate',
    [maxRatePlaceholder]: 'Enter Rate',
    [ruleIndexLabel]: 'Rule Index',
    [clientIpLabel]: 'Client IP',
    [ipReputationMatchLabel]: 'IP Reputation',
    [portMatchLabel]: 'Service Port',
    [allowLabel]: 'Allow',
    [denyLabel]: 'Deny',
    [rateLimitLabel]: 'Rate Limit',
    [networkSecurityRuleActionLabel]: 'Network Security Rule Action',
    [networkSecurityRuleActionPlaceholderLabel]: 'Select Network Security Rule Action',
    [geoMatchesLabel]: 'Geo Match',
};
